var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeMoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #ad974f;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -433.6,
    y: -432.1,
    width: 1361.2,
    height: 1361.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -433.6,
    y: -432.1,
    width: 1361.2,
    height: 1361.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_276aef62e6",
    "data-name": "276aef62e6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -433.6,
    y: -432.1,
    width: 1361.2,
    height: 1361.2
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.8,
    y: 126,
    width: 420.5,
    height: 248
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.6,
    y: 126.3,
    width: 418.4,
    height: 246
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M421.2,252.6c3.6-2.3,6.4-4.5,6.9-4.9,1.2-1.2-6.8-4.1-12.6-5.6-5-1.2-23.8-4.4-42.5,3.1l-4.1-9.3c8.9-5.8,17.2-10.1,23.8-14.2,20.7-13.2,15.8-25.6,5.3-41.4-5.8-8.8-24.9-30.1-27.4-31.9-7.1-7-20.2-18.6-22.7-20.3-4.5-3.1-15.6,1.6-18.5,3.5-.4.2-.8.5-1.3.8-3.2,2-6.6,4-5.8,6.8.7,2.3,3.7,3.2,11,3.2s22.7,9.7,28.3,16.4h0c3,3.8,4.6,7.4,4.7,9.2.4,4.6-7.4,11.1-22.1,12.2l-4.8-10.7c1.5-1.6,2.3-3.4,1.7-5-1.3-4,1.8-7.9-1.3-10.1-3.1-2.2-7.5-3.5-10.6-1.3-3.1,2.2-4,3.1-7.5,3.1s-5.7,0-7.5,2.2c-1.8,2.2.4,4.4.4,4.4l-8.8,4.8s-.4,5.7,4.8,4l11.4-4.4s1.2,5.9,6.5,6.5l3.8,8.4c-5.7,1.8-12,4.6-17.8,7.4-2.5-4-7.7-11.3-14.9-14.8-9.2-4.5-39.2-20.2-59.6-6.6-18.5,12.3-30.6,23.8-36.5,31.3-1.5-.6-3-1-4.3-1.1-6.3-.5-8.9-.7-22.4.5-22.4,1.9-32.3-3.4-36.3-5.3-.4-.2-.8-.3-1.2-.4-1.1-5-3-12.5-6.6-12.3-4.8.2-28.9,1.9-34.5.7-5.6-1.2-14.8-4.9-17-4.8-1.4,0-2.6,1.5-2.6,2.9-7.7-3.3-15.3-6.7-17.8-6.7s-3.4,2.9,1,4.1c4.3,1.2,10.9,16.4,10.4,17.9-.5,1.4,7.3,7,32.2,14.3,12.2,3.6,30.7,12.3,46.9,20.6-.6,4.8,2.1,19.1.7,19.7-1.7.7-4.1.7-10.2-3-8-4.9-16.2-5.4-15.7-4.3,0,0,0,.9,4.1,4.6-24.4-9.9-53.4-4-72,16.6-23.7,26.4-21.5,67.1,4.9,90.8,12.3,11,27.6,16.4,42.9,16.4s35.2-7.2,47.9-21.3h0c6.8-7.6,11.5-16.4,14-25.6,7.6,2.7,13,4.6,14.5,5.2,6,2.4,9.4,3.4,14.7,1.9,5.3-1.5,5.3,2.9,5.3,2.9l17.4.7s3.4-1.9,4.6-1.9,3.4,1.9,3.4,1.9c0,0,36.7.7,40.6.5,3.9-.2,4.8-2.9,8.9-3.4s30,4.1,37.2,4.8c7.3.7,4.4-5.8,2.9-7.7-.9-1.2-2.6-5.9-4.3-11.2,1.2.3,2.6-1.9,4.3-8.5,8.5-34.1,25.1-53.4,41.6-66.2l3.5,7.8c-20.7,13.6-27.4,36.1-27.4,36.1,0,0,1.7.5,3.7.9-2.7,6.9-4.2,14.5-4.2,22.4,0,34.2,27.9,62.1,62.1,62.1s62.1-27.9,62.1-62.1-15.7-47.8-38-57.2ZM136.4,333.4c-14.9,16.6-40.6,18-57.2,3.1-16.6-14.9-18-40.6-3.1-57.2,4.9-5.5,11-9.3,17.5-11.4-4.6,6-9.8,13.1-11.2,16.3-2.6,5.6,5.1,10.2,13.6,13.8-4.4,5.4-3.8,13.4,1.4,18.1,5.4,4.9,13.8,4.4,18.7-1,1.9-2.1,3-4.6,3.3-7.2l1-1c7.8,2.8,16.7,5.9,25.2,8.9-1.5,6.3-4.6,12.4-9.2,17.6ZM198.7,273.5c-2.9-1.5-8.7-7.5-12.3-9.9-3.6-2.4-7.3-3.7-9-4.4-1.7-.7-1.2-2.6,3.2-5.5,2.9-1.9,2.7-5.1,1.2-7.7,1.4.8,2.4,1.4,2.9,1.6,4,2.2,9.9,6.6,10.2,5.2,1,1.3,1.9,2.4,2.4,3,.7.9,1.2,1.8,1.7,2.5,1.2,3.8,3,10,4.3,12.7,1.9,3.9-1.7,3.9-4.6,2.4ZM363.2,154.9c-3.2-3.4-7.8-7.1-12.5-10-4.6-2.8-11.4-6.3-17.5-6.3s-5.6-.3-6.6-.5c.9-.8,2.6-1.8,3.5-2.4.5-.3,1-.6,1.4-.9,3.7-2.5,12.2-4.8,14.1-3.5,2.1,1.5,14.8,12.6,22,19.7-1.4,1.3-3.1,2.7-4.4,3.8ZM397.1,352.5c-23.5,0-42.7-19.2-42.7-42.7s7.6-27.9,19-35.5l12.6,28.4c-1.3,2.1-2.1,4.5-2.1,7.1,0,7.3,5.9,13.2,13.2,13.2s13.2-5.9,13.2-13.2-5.9-13.2-13.2-13.2-.8,0-1.2,0l-12.2-27.4c4.2-1.4,8.7-2.2,13.4-2.2,23.5,0,42.7,19.2,42.7,42.7s-19.2,42.7-42.7,42.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMoto);
export default __webpack_public_path__ + "static/media/Icone-moto.655a23ee43960e7b221c654d1c6a19d7.svg";
export { ForwardRef as ReactComponent };